import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@hero/web-components';
import { ImageOffIcon, PlusIcon } from '@hero/web-icons';

export interface OrderImagesEmptyProps {
  canAdd?: boolean;
  onAdd?: () => void;
}

export const OrderImagesEmpty: React.FC<OrderImagesEmptyProps> = ({ canAdd = false, onAdd }) => {
  const { t } = useTranslation('m-order');

  return (
    <div className="flex flex-col items-center justify-center px-8 py-16">
      <div className="mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-gray-100">
        <ImageOffIcon className="h-8 w-8 text-gray-400" />
      </div>

      <h3 className="mb-2 text-base font-semibold text-gray-700">
        {t('drawer.photos_empty.title')}
      </h3>

      <p className="max-w-xs text-center text-sm leading-relaxed text-gray-400">
        {canAdd
          ? t('drawer.photos_empty.description_can_add')
          : t('drawer.photos_empty.description')}
      </p>

      {canAdd && onAdd && (
        <Button type="button" size="md" className="mt-6" onClick={onAdd}>
          <PlusIcon className="size-4" />
          {t('drawer.photos_add')}
        </Button>
      )}
    </div>
  );
};
